import React from "react";
import PageContainerAuth from "../../components/common/PageContainerAuth";
import MediaCreateSection from "../../components/pages/media/create/MediaCreateSection";

export function MediaCreate() {

    return (
        <PageContainerAuth section="mailings-media" pageTitle="Nouveau média">
            <MediaCreateSection />
        </PageContainerAuth>
    );
}